export enum PermissionType {
  View = 'View',
  ManageMeteringPointGroup = 'ManageMeteringPointGroup',
  EditSettings = 'EditSettings',
  ViewInvoices = 'ViewInvoices',
  ViewAgreements = 'ViewAgreements',
  SignAgreements = 'SignAgreements',
  ViewServices = 'ViewServices',
  SignServices = 'SignServices',
  ManageAlarms = 'ManageAlarms',
  ManagePermissions = 'ManagePermissions',
  ManagePermissionManagers = 'ManagePermissionManagers',
  ManageMeteringPoints = 'ManageMeteringPoints',
  EditPrimaryContact = 'EditPrimaryContact',
  CreateInvite = 'CreateInvite'
}
